export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0003.1934801c.webp";